// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeAnalytics } from "firebase/analytics";
import { isTrackingEnabled } from "./utils/env";
import { getFirestore } from "firebase/firestore"; //Import firestore
import { getAuth } from "firebase/auth"; //Import auth
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDysWp2xMDkZk5k6ETTJNshPOWu5bAkd6w",
  authDomain: "letools-pg.firebaseapp.com",
  projectId: "letools-pg",
  storageBucket: "letools-pg.appspot.com",
  messagingSenderId: "469647317849",
  appId: "1:469647317849:web:99a0e92ec804ea29930a48",
  measurementId: "G-SZ26YPMM5W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Analytics: only initialized on the deployed site (never localhost/dev), so
// GA's automatic session events don't fire during testing. We also disable
// gtag's automatic page_view so (a) a directly-opened shared canvass link never
// sends its secret capability id in the URL to Google, and (b) we emit our own
// sanitized per-route page_view/tool_view events (see AnalyticsTracker in
// App.js). Wrapped so a blocked/unsupported browser can never white-screen.
let analytics = null;
if (isTrackingEnabled()) {
  try {
    analytics = initializeAnalytics(app, { config: { send_page_view: false } });
  } catch {
    analytics = null; // analytics unsupported or blocked — the app still works
  }
}
export { analytics };

export const auth = getAuth(app); //Make Auth available
export const db = getFirestore(app); // Make firestore available